import { Component, h, Element, Listen, Prop } from '@stencil/core';

@Component({
  tag: 'mama-tabs',
  styleUrl: './mama-tabs.scss',
})
export class MamaTabs {
  protected hasDefaultTab: boolean = false;

  @Element() el!: Element;

  @Prop() defaultTabNumber: number;

  private activeTabs: string[];
  private tabs: string[] = [];

  tabContent!: HTMLElement[];

  componentWillLoad() {
    this.setTabs();
    this.setActiveTabs();
    this.setDefaultTab();
  }

  componentDidLoad() {
    this.tabContent = Array.from(this.el.querySelectorAll('mama-tab-content')) as HTMLElement[];
    if (this.hasDefaultTab) {
      this.tabContent.forEach(content => {
        if (this.activeTabs && this.activeTabs.includes(content.getAttribute('name'))) {
          content.classList.add('active');
        }
      });
    } else {
      this.tabContent[0].classList.add('active');
    }
  }

  setTabs() {
    this.el.querySelectorAll('.tab-item').forEach(item => {
      if (item.getAttribute('value')) {
        this.tabs.push(item.getAttribute('value'));
      }
    });
  }

  setActiveTabs() {
    if (this.defaultTabNumber && this.tabs.length <= this.defaultTabNumber + 1) {
      this.activeTabs = [this.tabs[this.defaultTabNumber]];
    } else {
      if (JSON.parse(sessionStorage.getItem('mama-tabs'))) {
        this.activeTabs = JSON.parse(sessionStorage.getItem('mama-tabs'));
      } else {
        this.activeTabs = [];
      }
    }
  }

  setSessionStorage(id) {
    this.setActiveTabs();
    this.activeTabs = this.activeTabs.filter(x => !this.tabs.includes(x));
    this.activeTabs.push(id);
    sessionStorage.setItem('mama-tabs', JSON.stringify(this.activeTabs));
  }

  @Listen('mamaSelectChanged')
  tabChangeHandler(event: CustomEvent) {
    const activeTabID = event.detail.value;
    if (this.tabContent && event.currentTarget == this.el) {
      this.tabContent.forEach(content => {
        if (content.getAttribute('name') === activeTabID) {
          content.classList.add('active');
          this.setSessionStorage(activeTabID);
        } else {
          content.classList.remove('active');
        }
      });
    }
    if (event.detail.link) {
      sessionStorage.removeItem('mama-tabs');
      location.href = event.detail.link;
    }
  }

  setDefaultTab() {
    var tabHeadItems = Array.from(this.el.querySelectorAll('.tab-item')) as HTMLElement[];
    tabHeadItems.forEach(item => {
      if (this.activeTabs && this.activeTabs.includes(item.getAttribute('value'))) {
        item.classList.add('default');
        this.hasDefaultTab = true;
      }
    });
  }

  render() {
    return [
      <div class="tabs-header">
        <div class="form-group">
          <mama-select class="custom-select">
            <slot name="header" />
          </mama-select>
        </div>
      </div>,
      <div class="tabs-content">
        <slot name="content" />
      </div>,
    ];
  }
}
